import { format } from 'date-fns';
import _ from 'lodash';
import getMonth from 'date-fns/getMonth';
import getYear from 'date-fns/getYear';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';

const dateUtils = {
    formatJa: (date, lang) => format(new Date(date), lang === 'en' ? 'MMMM dd, yyyy (E)' : 'yyyy年MM月dd日 (E)', { locale: lang === 'en' ? enLocale : jaLocale }),
    formatJaMonthDayOnly: (date, lang) => format(new Date(date), lang === 'en' ? 'MMMM dd, yyyy (E)' : 'MM月dd日 (E)', { locale: lang === 'en' ? enLocale : jaLocale }),
    formatRange: (dateFrom, dateTo, lang) => {
        const yearEqual = getYear(new Date(dateFrom)) === getYear(new Date(dateTo));
        const monthEqual = getMonth(new Date(dateFrom)) === getMonth(new Date(dateTo));
        let range = `${dateUtils.formatJa(dateFrom, lang)} ~ ${dateUtils.formatJa(dateTo, lang)}`;
        if (monthEqual && yearEqual) {
            range = `${dateUtils.formatJa(dateFrom, lang)} ~ ${format(new Date(dateTo),
                lang === 'en' ? 'do (E)' : 'dd日 (E)',
                { locale: lang === 'en' ? enLocale : jaLocale })}`;
        } else if (yearEqual) {
            range = `${dateUtils.formatJa(dateFrom, lang)} ~ ${format(new Date(dateTo),
                lang === 'en' ? 'MMMM dd (E)' : 'MM月dd日 (E)',
                { locale: lang === 'en' ? enLocale : jaLocale })}`;
        }
        return range;
    },
};

export const convertDuration = (duration, textHour, textMinute, textSecond) => {
    if (!duration) {
        return '';
    }
    let minutes = Math.floor(duration / 60);
    const secs = duration % 60;
    const hours = Math.floor(minutes / 60);
    minutes %= 60;
    // return `${hours ? `${_.padStart(hours, 2, 0)}時` : ''}${minutes ? `${_.padStart(minutes, 2, 0)}分` : ''}${_.padStart(secs, 2, 0) || _.padStart(duration, 2, 0)}秒`;
    return `${hours ? `${_.padStart(hours, 2, 0)}${textHour}` : ''} ${minutes ? `${_.padStart(minutes, 2, 0)}${textMinute}` : ''} ${_.padStart(secs, 2, 0) || _.padStart(duration, 2, 0)}${textSecond}`;
};

export const utcDateNowTimeZoneTokyo = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));

export const isAfterEnd30Day = (endDate) => {
    const utcDateNow = utcDateNowTimeZoneTokyo();
    utcDateNow.setHours(0, 0, 0, 0);
    const timeRunningEnd = new Date(endDate);
    const time30Day = new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30));
    time30Day.setHours(0, 0, 0, 0);
    return utcDateNow >= time30Day;
};

export const isBeforeStart14Day = (startDate) => {
    const utcDateNow = utcDateNowTimeZoneTokyo();
    utcDateNow.setHours(0, 0, 0, 0);
    const timeRunningStart = new Date(startDate);
    const time14Day = new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 14));
    time14Day.setHours(0, 0, 0, 0);
    return utcDateNow < time14Day;
};

export const isBeforeUsingStartXdays=(startDate,xDayDiff) =>{
	 /* this function will return if this moment is before the day of (startDate - xDayDiff )*/ 
    const currentDate = new Date();
    const start_dd = new Date(startDate);
    if(currentDate > start_dd ){   // this case should return false because the show has been started.
    	return false;    
     }
	 const  utcDateNow = utcDateNowTimeZoneTokyo();
    utcDateNow.setHours(0, 0, 0, 0);
    const timeRunningStart = new Date(startDate);
    const timeBeforeXdiffDay = new Date(timeRunningStart.setDate(timeRunningStart.getDate() - parseInt( xDayDiff )));
    timeBeforeXdiffDay.setHours(0, 0, 0, 0);
    return utcDateNow < timeBeforeXdiffDay;
};
export const isAfterUsingEndXdays=(endDate,xDayDiff) =>{
	 /* this function will return if this moment is after the day of (endDate + xDayDiff )*/ 
    const currentDate = new Date();
    const end_dd = new Date(endDate);
    if(currentDate < end_dd ){   // this case should return false because the show has not yet been closed .
    	return false;
     }

	 const  utcDateNow = utcDateNowTimeZoneTokyo();
    utcDateNow.setHours(0, 0, 0, 0);
    const timeRunningEnd = new Date(endDate);
    const timeAfterXdiffDay = new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + parseInt( xDayDiff ) ));
    timeAfterXdiffDay.setHours(0, 0, 0, 0);
    return utcDateNow > timeAfterXdiffDay;
};


export default dateUtils;
